import React from "react";
import { MASS_UNITS } from "../../constants";
import "./printableComponent.css";

const SummaryPrintableComponent = React.forwardRef(
  ({ summaryData, day, date, generateMixerChartTable, documentData }, ref) => {
    const unit = MASS_UNITS?.[0];

    const getMixValues = (ingredient) => {
      const fullMixes = Math.floor(ingredient.mixes);
      const remainingMix = ingredient.mixes - fullMixes;
      const remainingMixValue =
        remainingMix > 0
          ? Math.max(ingredient.mixMin, remainingMix * ingredient.mixMax)
          : 0;

      const fullValues = Array.from({ length: fullMixes }, () =>
        `${ingredient.mixMax / unit.amount} ${unit.abbreviation}`
      );

      const remainder =
        remainingMix > 0
          ? [`${Math.ceil(remainingMixValue / unit.amount)} ${unit.abbreviation}`]
          : [];

      return [...fullValues, ...remainder];
    };

    return (
      <div ref={ref} className="printable-container-summary">
        <h3 style={{ display: "inline", marginRight: "10px" }}>Production Summary</h3> {day} {date}

        {/* SHEET 1: MIXES */}
        {summaryData.map((list, listIndex) => (
          <div key={`mix-list-${listIndex}`}>
            <p>Production List: {list.listName}</p>

            {list.lines.map((line, lineIndex) => (
              <div key={`mix-line-${lineIndex}`} className="line-block">
                <strong>Line: {line.lineName}</strong>

                <table className="production-summary-table">
                  {/* <thead>
                    <tr>
                      <th className="product-col">Product</th>
                      <th>Mix Weights</th>
                    </tr>
                  </thead> */}
                  <tbody>
                    {line.products.map((product, productIndex) =>
                      product.ingredientDetails.map((ingredient, ingredientIndex) => {
                        const mixValues = getMixValues(ingredient);

                        return (
                          <tr key={`ingredient-${productIndex}-${ingredientIndex}`} className="ingredient-row">
                            <td className="product-col">
                              <span className="ingredient-product">{product.productName}</span>{" "}
                              <span className="ingredient-code">({ingredient.manufacturerCode})</span>
                            </td>
                            <td className="mix-col">
                              <div className="mix-wrap">
                                {mixValues.map((value, i) => (
                                  <span key={`mix-${i}`} className="mix-item">
                                    {value}
                                  </span>
                                ))}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        ))}

        <div className="page-break" />

        {/* SHEET 2: PIECES / EXTRA */}
        {summaryData.map((list, listIndex) => (
          <div key={`qty-list-${listIndex}`}>
            <p>Production List: {list.listName}</p>

            {list.lines.map((line, lineIndex) => (
              <div key={`qty-line-${lineIndex}`} className="line-block">
                <strong>Line: {line.lineName}</strong>

                <table className="production-summary-table qty-table">
                  <thead>
                    <tr>
                      <th className="product-col">Product</th>
                      <th>Pieces</th>
                      <th>Extra</th>
                    </tr>
                  </thead>
                  <tbody>
                    {line.products.map((product, productIndex) => {
                      if (!(product.filledQuantity > 0 || product.extra > 0)) return null;

                      const pieces =
                        product.filledQuantity > product.onHand
                          ? (product.filledQuantity - product.onHand) * Number(product.pieceCount)
                          : 0;

                      const piecesUnits =
                        product.pieceCount > 1 && product.filledQuantity > product.onHand
                          ? ` (${product.filledQuantity - product.onHand} ${product.unitName}'s)`
                          : "";

                      const extraBase = product.extra - Math.max(product.onHand - product.filledQuantity, 0);
                      const extra = product.onHand - product.filledQuantity - product.extra > 0
                        ? 0
                        : extraBase * Number(product.pieceCount);

                      const extraUnits =
                        product.pieceCount > 1 && !(product.onHand - product.filledQuantity - product.extra > 0)
                          ? ` (${extraBase} ${product.unitName}'s)`
                          : "";

                      return (
                        <tr key={`qty-product-${productIndex}`}>
                          <td className="product-col">{product.productName}</td>
                          <td>{pieces}{piecesUnits}</td>
                          <td>{extra}{extraUnits}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
        ))}

        <div className="page-break" />
        {generateMixerChartTable()}
      </div>
    );
  }
);

export default SummaryPrintableComponent;